import { FC } from 'react';

import { Toast } from '../Toast';

import { SizeFormat } from 'types';

interface IPopoverHintProps {
  isVisible: boolean;
  backgroundColor?: string;
  maxWidth?: SizeFormat;
  borderColor?: string;
}

/** Compatibility adapter for existing controlled notifications. */
const PopoverHint: FC<IPopoverHintProps> = ({
  isVisible,
  children,
  backgroundColor,
  maxWidth,
  borderColor,
}) =>
  isVisible ? (
    <Toast style={{ backgroundColor, maxWidth, borderColor }}>{children}</Toast>
  ) : null;

export { PopoverHint };
